module.exports = __webpack_public_path__ + "static/img/FORTNITEpreset.8ada0b4c.png";